import { useEffect } from 'react';
import { SoftphoneWidget } from '@/components/softphone/SoftphoneWidget';
import { PostMessageBridge } from '@/lib/postmessage-bridge';
import { useSoftphone } from '@/store/softphone';

/**
 * Mode B — minimal iframe-friendly view.
 * Host page passes JWT via ?token=... query and receives events via postMessage.
 */
export default function Embed() {
  const { dial, hangup } = useSoftphone();

  useEffect(() => {
    const bridge = new PostMessageBridge({
      allowedOrigins: '*', // TODO: lock down per-tenant
      onCommand: (cmd) => {
        if (cmd.command === 'dial') dial(cmd.number);
        if (cmd.command === 'hangup') hangup();
      },
    });
    bridge.start();
    return () => bridge.stop();
  }, [dial, hangup]);

  return (
    <div className="p-2">
      <SoftphoneWidget />
    </div>
  );
}
